export default {
  methods: {
    // localStorage
    localStorageSet(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },
    localStorageGet(key, defaultValue) {
      let data = localStorage.getItem(key);

      if (data) {
        data = JSON.parse(data);
      } else {
        data = defaultValue;
      }

      return data;
    },
    localStorageDelete(key) {
      localStorage.removeItem(key);
    },

    // sessionStorage
    sessionStorageSet(key, data) {
      sessionStorage.setItem(key, JSON.stringify(data));
    },
    sessionStorageGet(key, defaultValue) {
      let data = sessionStorage.getItem(key);

      if (data) {
        data = JSON.parse(data);
      } else {
        data = defaultValue;
      }

      return data;
    },
    sessionStorageDelete(key) {
      sessionStorage.removeItem(key);
    },
  },
};
